import { ADVANCED_SEARCH_OPTIONS } from '@/utils/constants';
import { SearchResultColumns } from './SearchResult';

export { getColumnsDefinition, SearchResultColumns } from './SearchResult';

export const SEARCH_COLUMN_MAPPING: Record<ADVANCED_SEARCH_OPTIONS, SearchResultColumns[]> = {
  [ADVANCED_SEARCH_OPTIONS.FUNDS]: [
    SearchResultColumns.IS_SAVED,
    SearchResultColumns.TICKER,
    SearchResultColumns.NAME,
    SearchResultColumns.UNIVERSE,
    SearchResultColumns.CLASSIFICATION,
    SearchResultColumns.ONE_YEAR,
    SearchResultColumns.THREE_YEARS,
    SearchResultColumns.FIVE_YEARS,
    SearchResultColumns.INC,
    SearchResultColumns.MER,
    SearchResultColumns.BETA,
    SearchResultColumns.STD_DEV,
    SearchResultColumns.IS_FOCUSED,
  ],
  [ADVANCED_SEARCH_OPTIONS.PROXIES]: [
    SearchResultColumns.IS_SAVED,
    SearchResultColumns.TICKER,
    SearchResultColumns.NAME,
    SearchResultColumns.UNIVERSE,
    SearchResultColumns.CLASSIFICATION,
    SearchResultColumns.ONE_YEAR,
    SearchResultColumns.THREE_YEARS,
    SearchResultColumns.FIVE_YEARS,
    SearchResultColumns.INC,
    SearchResultColumns.MER,
    SearchResultColumns.BETA,
    SearchResultColumns.STD_DEV,
    SearchResultColumns.IS_FOCUSED,
  ],
  [ADVANCED_SEARCH_OPTIONS.BENCHMARKS]: [
    SearchResultColumns.IS_SAVED,
    SearchResultColumns.NAME,
    SearchResultColumns.CLASSIFICATION,
    SearchResultColumns.YT,
    SearchResultColumns.THREE_YEARS,
    SearchResultColumns.FIVE_YEARS,
    SearchResultColumns.TEN_YEARS,
    SearchResultColumns.STD_DEV,
  ],
  [ADVANCED_SEARCH_OPTIONS.STOCKS]: [
    SearchResultColumns.IS_SAVED,
    SearchResultColumns.TICKER,
    SearchResultColumns.NAME,
    SearchResultColumns.UNIVERSE,
    SearchResultColumns.CLASSIFICATION,
    SearchResultColumns.ONE_YEAR,
    SearchResultColumns.THREE_YEARS,
    SearchResultColumns.FIVE_YEARS,
    SearchResultColumns.INC,
    SearchResultColumns.MER,
    SearchResultColumns.BETA,
    SearchResultColumns.STD_DEV,
    SearchResultColumns.IS_FOCUSED,
  ],
  [ADVANCED_SEARCH_OPTIONS.BONDS]: [
    SearchResultColumns.IS_SAVED,
    SearchResultColumns.TICKER,
    SearchResultColumns.NAME,
    SearchResultColumns.UNIVERSE,
    SearchResultColumns.CLASSIFICATION,
    SearchResultColumns.ONE_YEAR,
    SearchResultColumns.THREE_YEARS,
    SearchResultColumns.FIVE_YEARS,
    SearchResultColumns.INC,
    SearchResultColumns.MER,
    SearchResultColumns.BETA,
    SearchResultColumns.STD_DEV,
    SearchResultColumns.IS_FOCUSED,
  ],
};
